import * as angular from 'angular';
import AppConstants from '../gorillaboy/AppConstants';
import SignalProvider from '../gorillaboy/SignalProvider';
import {RootScope} from '../types/angular-types';
import {ISelectionManager, ISelectedItem} from '../types/selectionManager';

import './right_click_menus/rightClickMenuContentDirectives';
import './right_click_menus/right_click_menu.html'

interface MenuPosition {
    top: number,
    left: number
}

interface RightClickDirectiveScope extends RootScope {
    menuTemplate: string;
    displayMenu: boolean;
    menuStyle: MenuPosition;
    selectedItems: ISelectedItem[];
    selectedItem: any;
    rightClickMenus: any;
    selectionManager: ISelectionManager;
}


angular.module('GorillaBoy.directives')
    .directive('rightClickMenu', [
        '$document',
        '$log',
        '$timeout',
        '$window',
        function rightClickMenu($document: ng.IDocumentService, $log: ng.ILogService, $timeout:ng.ITimeoutService,$window: Window) {
            return {
                restrict: 'A',
                transclude: true,
                scope: true,
                templateUrl: './file-browser/right_click_menus/right_click_menu.html',
                link: function($scope: RightClickDirectiveScope, $element, $attrs) {
                    // Validation before Initialization
                    if (!$scope.isFeatureEnabled($scope.Features.UI.RIGHT_CLICK_MENU)) {
                        return;
                    }

                    if (!$scope.$eval($attrs.selectionManager)) {
                        $log.error('rightClickMenu: No selectionManager found');
                        return;
                    }

                    if (!$scope.$eval($attrs.rightClickMenu)) {
                        return;
                    }

                    // Initialization
                    $scope.menuTemplate = null;
                    $scope.displayMenu = false;
                    $scope.menuStyle = null;
                    $scope.selectedItems = null;
                    $scope.selectedItem = null;
                    $scope.rightClickMenus = AppConstants.RightClickMenus;
                    $scope.selectionManager = $scope.$eval($attrs.selectionManager);

                    // Add Listeners
                    $scope.$on(SignalProvider.Selection.SelectionUpdated, function() {
                        // Put the update function in timeout to make sure the local $scope.folders and $scope.files
                        // have been synchronized.
                        $timeout(function() {
                            updateMenuTemplate();
                            updateSelecctedItems();
                        });
                    });

                    $element.on('contextmenu', function rightClickHandler(event) {
                        event.preventDefault();
                        // Prevent click action on the menu itself
                        if (clickedOnMenu(event)) {
                            return;
                        }

                        $scope.$apply(function() {
                            if (isMenuShown()) {
                                hideMenu();
                            }
                            
                            selectClickedItem(event.target);
                            updateMenuTemplate();

                            if ($scope.menuTemplate !== null) {
                                // Have to wait until the template is updated before the next operation
                                $timeout(function() {
                                    showMenu(computeMenuPosition($element, event));
                                });
                            }
                            
                            
                        });
                    });

                    $document.on('click', clickHandler);

                    $scope.$on("$destroy", function() {
                        $document.off('click', clickHandler);
                    });

                    function clickHandler() {
                        if (isMenuShown()) {
                            $scope.$apply(function() {
                                hideMenu();
                            });
                        }
                    }

                    function clickedOnMenu(event) {
                        let hasRightClickMenuAsParent = $(event.target).closest('.right-click-menu');
                        return !!hasRightClickMenuAsParent.length;
                    }

                    function selectClickedItem(clickTargetDOM) {
                        var resourceEntry = $(clickTargetDOM).closest('.resource-entry');
                        if (!resourceEntry.length) {
                            return;
                        }
                        resourceEntry = $(resourceEntry);
                        let resourceId = resourceEntry.data('id');
                        let resourceType = $scope.selectionManager.getItemType(resourceId);
                        let isResourceSelected = $scope.selectionManager.isSelected(resourceType, resourceId);

                        if (!isResourceSelected) {
                            $scope.selectionManager.clearSelected();
                            $scope.selectionManager.markAsSelected(resourceType, resourceId);
                        }
                    }

                    function updateMenuTemplate() {
                        $scope.menuTemplate = $scope.selectionManager.getRightClickMenuType();
                    }

                    function updateSelecctedItems() {
                        $scope.selectedItems = $scope.selectionManager.getSelectedItems();
                        if ($scope.selectedItems.length !== 1) {
                            $scope.selectedItem = null;
                        } else {
                            $scope.selectedItem = $scope.selectedItems[0];
                        }
                    }

                    function computeMenuPosition(containerDOM, clickEvent): MenuPosition {
                        let pos = {
                            top: clickEvent.pageY - containerDOM.offset().top,
                            left: clickEvent.pageX - containerDOM.offset().left
                        } as MenuPosition;

                        var menu = $element.children('.right-click-menu');

                        // temporarily set display to blcok to get BCR
                        menu[0].style.display = 'block';
                        var menuBCR = menu[0].getBoundingClientRect();
                        menu[0].style.display = '';
                        var outOfRight = isMenuOutOfRightEdge(menuBCR, pos);
                        var outOfBottom = isMenuOutOfBottomEdge(menuBCR, pos);
                        if (outOfRight) {
                            pos.left -= menuBCR.width;
                        }
                        if (outOfBottom) {
                            pos.top -= menuBCR.height;
                        }
                        return pos;
                    }

                    function isMenuShown() {
                        var menu = $element.children('.right-click-menu');
                        return menu.hasClass('open');
                    }

                    function hideMenu() {
                        $scope.displayMenu = false;
                        $scope.menuStyle = null;
                    }

                    function showMenu(menuPosition) {
                        $scope.displayMenu = true;
                        $scope.menuStyle = menuPosition;
                    }

                    function isMenuOutOfRightEdge(menuBCR, pos) {
                        var windowWidth = $(window).width();
                        var menuRightEdge = $element.offset().left + pos.left + menuBCR.width;
                        return menuRightEdge > windowWidth;
                    }

                    function isMenuOutOfBottomEdge(menuBCR, pos) {
                        var windowHeight = $(window).height();
                        var menuBottomEdge = $element.offset().top + pos.top + menuBCR.height;
                        return menuBottomEdge > windowHeight;
                    }
                }
            }


            
    }]);